import styles from "./BrandFilter.module.css"
import { useBrandFilter } from '../../../hooks/useBrandFilter';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';
import { BrandFilterOptions } from './brandFilterOptions/BrandFilterOptions';
import { CollapsibleCard } from "../../../module/brand-filter/components/collapsible-card/collapsible-card";

export function BrandFilter() {
    const steps = [
        "Шаг 1: Выберите тип автомобиля",
        "Шаг 2: Выберите марку",
        "Шаг 3: Выберите модель",
        "Шаг 4: Укажите объем двигателя",
        "Шаг 5: Нажмите поиск"
    ];
    const { data, isLoadingEngineProduct, isRefetching } = useBrandFilter()

    return (
        <MarkupLayout>
            <section className={`${styles.brand_filter_section_container} ${(isRefetching || isLoadingEngineProduct) && styles.brand_filter_section_container_loading}`}>
                <BrandFilterOptions />
                <CollapsibleCard product={(data && data) || []} />
                {
                    !data && <div className={styles.steps_container}>
                        <ul className={styles.steps_list}>
                            {steps.map((step, index) => (
                                <li key={index} className={styles.step_item}>
                                    <span className={styles.step_number}>{index + 1}</span>
                                    <span className={styles.step_text}>{step}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                }


            </section>
        </MarkupLayout>
    )
}

